exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gw-cart-summary .gw-summary-item{color:#fff}.gw-order-pane{position:relative;margin-bottom:.75em;padding-bottom:.75em;border-bottom:1px solid #d4d4d4;cursor:pointer}.gw-cart-summary .gw-order-pane{border-bottom-color:#556870}.gw-order-pane__summary{display:block;padding-left:.75rem}.gw-order-pane__summary::-webkit-details-marker{display:none}.gw-order-pane__summary:focus{outline:none}.gw-order-pane__summary:before{position:absolute;top:.375em;left:0;width:.3125em;height:.625em;background:no-repeat 50% url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 5 10'%3E%3Cpath fill='none' fill-rule='evenodd' stroke='%23D8D8D8' stroke-width='1.5' d='M1 1l3 3.97L1 8.8' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");background-size:.3125em .625em;content:\"\";opacity:.6}.is-open .gw-order-pane__summary:before{transform:rotate(90deg)}.gw-order-pane__body{margin-top:.75em;padding-left:.75em;font-weight:300}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./resources/assets/js/common/summary/summary-item/summary-item.scss
// module id = 2InD
// module chunks = 1